import { getBetHistory } from "@/lobby_common/api/game_gen";
let vm = null;
const sendGrandPrizeThis = (_this) => {
  vm = _this;
};

let betList = []; // 高额投注列表
let betIndex = 0; // 当前展示大奖在列表中索引
// const timer = null; // 计时器

const initGrandPrizeList = async (position) => {
  if (betList.length > 0) {
    openGrandPrizeFun(position);
    return;
  }
  const res = await getBetHistory({
    limit: 50,
    betType: "JACKPOT",
  });
  if (res?.code === 0) {
    const list = res.data.list || [];
    if (list.length < 1) return;
    const gameInfos = res.data.gameInfo || {};
    const coinIcons = res.data.coinIcons || {};
    const originData = list.map((e) => {
      const gameInfo = gameInfos[e.gameGroupSid] || {};
      return {
        ...e,
        ...gameInfo,
        miniOrH5: gameInfo.gameH5Icon,
        appOrPcUrl: gameInfo.gamePcIcon,
        coin_icon: coinIcons[e.coinCode],
        // eid: `101_24_${this.curindex}_${e.gameGroupSid}`,
      };
    });
    // originData = originData.filter(
    //   (e) => e.miniOrH5 !== "" && e.appOrPcUrl !== ""
    // );
    betList = originData;
    // console.log("======大奖betList======", betList);
    openGrandPrizeFun(position);
  }
};

// const clearGrandPrizeTimer = () => {
//   timer && clearInterval(timer);
//   betList = [];
//   betIndex = 0;
// };

// 每30s上传弹一次
// 条件: 在首页，并且无其他弹窗
const openGrandPrizeFun = (position = "") => {
  // timer && clearInterval(timer);
  // timer = setInterval(async () => {
  // console.log("handleGrandPrizeTip执行", vm.$route.path, vm.$route.fullPath);
  // if (vm.$route.path !== "/home" && vm.$route.path !== "/") return;
  // 已登录且已充值
  const userInfo = vm.$store.getters.user || {};
  if (vm.$store.getters.login && userInfo.isRecharge) {
    vm.$popConfig.winConfigNext();
    return;
  }
  // const dialogs = document.querySelectorAll(
  //   '.el-dialog__wrapper:not([style*="display: none"])'
  // );
  // console.log("dialogs", dialogs);
  // 无其他弹窗弹出
  // if (!dialogs.length) {
  if (betIndex >= betList.length - 1) {
    betIndex = 0;
  }
  const curPrize = betList[betIndex];
  if (curPrize) {
    console.log("当前大奖", betIndex, curPrize);
    betIndex++;
    vm.$Bus.$emit("grandPrizeGuide", { ...curPrize, position });
  } else {
    vm.$popConfig.winConfigNext();
  }
  // }
  // }, 30000);
};

export default {
  sendGrandPrizeThis,
  initGrandPrizeList,
  // clearGrandPrizeTimer,
  openGrandPrizeFun,
};
